import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardComponent implements OnInit, AfterViewInit {

  faEllipsisV = faEllipsisV;

  @Input()
  image: string = null;

  @Input()
  title: string = null;

  @Input()
  text: string = null;

  @Input()
  link: string = null;

  @Input()
  shadow = true;

  @Input()
  fixed = false;

  @ViewChild('actionsWrapper') actionsWrapper: ElementRef;

  hasActions = false;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.hasActions = Array.from(this.actionsWrapper.nativeElement.childNodes).filter((el: Node) => el.nodeName != '#comment').length > 0;
    });
  }

}
